
<template>
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M13.3333 7.50016L17.5 5.8335V14.1668L13.3333 12.5002M3.33333 15.4168H12.5C12.9602 15.4168 13.3333 15.0437 13.3333 14.5835V5.41683C13.3333 4.95659 12.9602 4.5835 12.5 4.5835H3.33333C2.8731 4.5835 2.5 4.95659 2.5 5.41683V14.5835C2.5 15.0437 2.8731 15.4168 3.33333 15.4168Z"
            stroke="#323030"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
</template>
<script>
export default {
    name: "CameraIcon"
}
</script>
